import type { EexCapability } from "@chro/shared";
import { eexCapabilitiesFor } from "../../lib/eex-access";
import { useAuth } from "../../stores/auth";

export function useEexCapability(capability: EexCapability): boolean {
  return useAuth(state => !!state.user && eexCapabilitiesFor(state.user)[capability]);
}
